export default {
    'add-external-entity': 'Add external entity ',
    'edit-external-entity': 'Edit external entity',
    'this-entity-data': 'this entity data'
}